import { render } from "./SubscriberstartCom.vue?vue&type=template&id=2a7d87c2&scoped=true"
const script = {}

import "./SubscriberstartCom.vue?vue&type=style&index=0&id=2a7d87c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7d87c2"]])

export default __exports__